import { Component, EventEmitter, input, OnInit, Output, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { formInput, formRow, formSelect, RktFormComponent } from '@rocketfinancialcorp/rocket-ui/form';
import { FinancialAccountRestriction, FormModel } from '@shared/models';
import { Patterns } from '@shared/utils';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-restriction-edit-item-field',
  templateUrl: './restriction-edit-item-field.component.html',
  standalone: true,
  imports: [ReactiveFormsModule, RktFormComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RestrictionEditItemFieldComponent implements OnInit, OnDestroy {
  restriction = input.required<FinancialAccountRestriction>();

  @Output() changed = new EventEmitter<FinancialAccountRestriction>();

  @Output() errored = new EventEmitter<boolean>();

  restrictionForm = new FormGroup({});

  formModel: FormModel<{ withholdingPeriod: string; withholdingPeriodType: string }> = {};

  restrictionFormFields = [
    formRow([
      formInput({
        key: 'withholdingPeriod',
        label: 'Withholding Period',
        props: { required: true, pattern: Patterns.ISO_8601_FORMAT },
        validation: {
          messages: {
            required: 'Required Field',
            pattern: 'Invalid ISO 8601 format',
          },
        },
      }),
      formSelect({
        key: 'withholdingPeriodType',
        label: 'Withholding Period Type',
        props: {
          placeholder: 'Select',
          options: [
            { value: 'BANKING_DAY', label: 'BANKING_DAY' },
            { value: 'CALENDAR_DAY', label: 'CALENDAR_DAY' },
          ],
          required: true,
        },
        validation: {
          messages: {
            required: 'Required Field',
          },
        },
      }),
    ]),
  ];

  private destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.formModel = {
      withholdingPeriod: this.restriction().withholdingPeriod,
      withholdingPeriodType: this.restriction().withholdingPeriodType,
    };

    this.restrictionForm.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.errored.emit(this.restrictionForm.invalid);
      if (this.restrictionForm.invalid) {
        return;
      }
      const updatedRestriction = { ...this.restriction(), ...this.formModel };
      this.changed.emit(updatedRestriction);
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
